import { render, staticRenderFns } from "./shippingOrderList.vue?vue&type=template&id=cfc35ff4"
import script from "./shippingOrderList.vue?vue&type=script&lang=js"
export * from "./shippingOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports